import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Aug 09 2018
 * @author VBr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { observable, runInAction, action } from 'mobx';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
export var ErrorStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(ErrorStore, _BaseStore);

  function ErrorStore() {
    var _this;

    _classCallCheck(this, ErrorStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ErrorStore).apply(this, arguments));
    _this.name = StoreName.Error;
    _this.errors = [];
    return _this;
  }
  /**
   * Sets error which occured in store
   * @param error
   * @param errorInfo
   */


  _createClass(ErrorStore, [{
    key: "setError",
    value: function setError(errorInfo) {
      var _this2 = this;

      runInAction(function () {
        _this2.errors = [].concat(_toConsumableArray(_this2.errors), [{
          errorInfo: errorInfo
        }]);
      });
    }
  }]);

  return ErrorStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Array)], ErrorStore.prototype, "errors", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], ErrorStore.prototype, "setError", null);